'use strict';

/**
 * Fullscreen product images (snippets/product-lightbox.liquid), Knut 2026-10-03, design B + C.
 *
 * Gestures are handled with pointer events (no library), so mobile and desktop share one model:
 * - One finger / mouse, not zoomed: swipe left/right changes image, drag down closes (touch).
 * - Two fingers: pinch zoom (1–4x) around the fingers. Double-tap (touch) or click (mouse) toggles 2.5x at the
 *   point. Mouse wheel zooms at the pointer. Zoomed: drag to pan.
 * - Arrows, arrow keys, thumbnails; Esc, × and the Android back button close.
 * The 2400 px image is loaded the first time an image is zoomed.
 * Also: the image counter on the product gallery and openers ([data-lb-open]).
 */
(function () {
  var dlg = document.querySelector('[data-lightbox]');
  if (!dlg || typeof dlg.showModal !== 'function') return;

  var stage = dlg.querySelector('[data-lb-stage]');
  var track = dlg.querySelector('[data-lb-track]');
  var imgs = Array.prototype.slice.call(dlg.querySelectorAll('[data-lb-img]'));
  var thumbs = Array.prototype.slice.call(dlg.querySelectorAll('[data-lb-thumb]'));
  var count = dlg.querySelector('[data-lb-count]');
  var hint = dlg.querySelector('[data-lb-hint]');
  var total = imgs.length;
  var MAX = 4, STEP = 2.5;

  var index = 0, s = 1, x = 0, y = 0, base = null;
  var pointers = new Map(), mode = null, start = null, pinch = null, lastTap = null;
  var opener = null, pushed = false;

  /* ---------- zoom ---------- */

  function img() { return imgs[index]; }

  function measure() {
    var r = img().getBoundingClientRect();
    base = { left: r.left - x, top: r.top - y, width: r.width / s, height: r.height / s };
  }

  function clampPan() {
    if (!base) return;
    x = Math.min(0, Math.max(base.width - base.width * s, x));
    y = Math.min(0, Math.max(base.height - base.height * s, y));
  }

  function apply(animate) {
    var el = img();
    el.style.transition = animate ? 'transform .2s ease-out' : 'none';
    el.style.transform = s === 1 ? '' : 'translate(' + x + 'px,' + y + 'px) scale(' + s + ')';
    stage.classList.toggle('is-zoomed', s > 1);
  }

  function hiRes(el) {
    if (el.dataset.zoomSrc && !el.dataset.hi) { el.dataset.hi = '1'; el.src = el.dataset.zoomSrc; }
  }

  /* Keep the point (cx, cy) under the finger/pointer while changing the scale. */
  function zoomAt(cx, cy, next) {
    if (s === 1 || !base) measure();
    next = Math.max(1, Math.min(MAX, next));
    var px = cx - base.left, py = cy - base.top;
    var qx = (px - x) / s, qy = (py - y) / s;
    s = next;
    x = px - qx * s;
    y = py - qy * s;
    if (s === 1) { x = 0; y = 0; }
    clampPan();
    if (s > 1) hiRes(img());
  }

  function resetZoom(animate) { s = 1; x = 0; y = 0; if (imgs[index]) apply(animate); }

  function toggleZoom(cx, cy) {
    if (s > 1) { resetZoom(true); return; }
    zoomAt(cx, cy, STEP);
    apply(true);
  }

  /* ---------- navigation ---------- */

  function go(i, animate) {
    if (imgs[index]) resetZoom(false);
    index = Math.max(0, Math.min(total - 1, i));
    track.style.transition = animate === false ? 'none' : 'transform .25s ease-out';
    track.style.transform = 'translateX(' + (-index * 100) + '%)';
    count.textContent = (index + 1) + ' / ' + total;
    thumbs.forEach(function (t, n) { t.setAttribute('aria-current', String(n === index)); });
    var active = thumbs[index];
    if (active && active.scrollIntoView) active.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    [index - 1, index, index + 1].forEach(function (n) { if (imgs[n]) imgs[n].loading = 'eager'; });
    dlg.classList.toggle('is-first', index === 0);
    dlg.classList.toggle('is-last', index === total - 1);
  }

  function open(i, from) {
    opener = from || document.activeElement;
    if (!dlg.open) dlg.showModal();
    document.documentElement.classList.add('pp-lb-open');
    go(i || 0, false);
    try { history.pushState({ ppLightbox: true }, ''); pushed = true; } catch (e) { pushed = false; }
    var coarse = window.matchMedia('(pointer: coarse)').matches;
    var seen = false;
    try { seen = sessionStorage.getItem('pp-lb-hint') === '1'; sessionStorage.setItem('pp-lb-hint', '1'); } catch (e) { /* ignore */ }
    if (hint && coarse && !seen) {
      hint.hidden = false;
      setTimeout(function () { hint.hidden = true; }, 2600);
    }
  }

  function close(fromHistory) {
    if (!dlg.open) return;
    resetZoom(false);
    stage.style.transform = '';
    dlg.style.backgroundColor = '';
    dlg.close();
    document.documentElement.classList.remove('pp-lb-open');
    if (!fromHistory && pushed && history.state && history.state.ppLightbox) history.back();
    pushed = false;
    if (opener && opener.focus && document.contains(opener)) opener.focus({ preventScroll: true });
  }

  /* ---------- pointer gestures ---------- */

  function dist(a, b) { return Math.hypot(a.x - b.x, a.y - b.y); }
  function mid(a, b) { return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 }; }

  stage.addEventListener('pointerdown', function (e) {
    if (e.target.closest('button')) return;
    try { stage.setPointerCapture(e.pointerId); } catch (err) { /* unknown pointer (synthetic) – gestures still work */ }
    pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (pointers.size === 2) {
      var p = Array.from(pointers.values());
      if (s === 1) measure();
      mode = 'pinch';
      pinch = { d: dist(p[0], p[1]), s: s };
      return;
    }
    if (pointers.size === 1) {
      mode = s > 1 ? 'pan' : 'swipe';
      start = { x: e.clientX, y: e.clientY, t: Date.now(), x0: x, y0: y, moved: false };
    }
  });

  stage.addEventListener('pointermove', function (e) {
    if (!pointers.has(e.pointerId)) return;
    pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (mode === 'pinch' && pointers.size >= 2) {
      var p = Array.from(pointers.values());
      var m = mid(p[0], p[1]);
      zoomAt(m.x, m.y, pinch.s * dist(p[0], p[1]) / pinch.d);
      apply(false);
      return;
    }
    if (!start) return;
    var dx = e.clientX - start.x, dy = e.clientY - start.y;
    if (Math.abs(dx) > 6 || Math.abs(dy) > 6) start.moved = true;
    if (mode === 'pan') {
      x = start.x0 + dx; y = start.y0 + dy;
      clampPan();
      apply(false);
    } else if (mode === 'swipe' && start.moved) {
      if (e.pointerType !== 'mouse' && dy > 0 && Math.abs(dy) > Math.abs(dx)) {
        stage.style.transform = 'translateY(' + dy + 'px)';
        dlg.style.backgroundColor = 'rgba(31, 23, 18, ' + Math.max(0.35, 0.95 - dy / 400) + ')';
      } else {
        track.style.transition = 'none';
        track.style.transform = 'translateX(calc(' + (-index * 100) + '% + ' + dx + 'px))';
      }
    }
  });

  function end(e) {
    if (!pointers.has(e.pointerId)) return;
    pointers.delete(e.pointerId);
    if (mode === 'pinch') {
      if (pointers.size < 2) {
        if (s < 1.05) resetZoom(true);
        var rest = Array.from(pointers.values())[0];
        mode = rest && s > 1 ? 'pan' : null;
        start = rest ? { x: rest.x, y: rest.y, t: Date.now(), x0: x, y0: y, moved: true } : null;
      }
      return;
    }
    if (!start) return;
    var dx = e.clientX - start.x, dy = e.clientY - start.y, dt = Date.now() - start.t;
    var wasTap = !start.moved && dt < 350;
    if (mode === 'swipe' && !wasTap) {
      stage.style.transform = '';
      dlg.style.backgroundColor = '';
      if (e.pointerType !== 'mouse' && dy > 110 && Math.abs(dy) > Math.abs(dx)) { start = null; mode = null; close(); return; }
      var swipe = Math.abs(dx) > 50 || (Math.abs(dx) > 20 && dt < 250);
      go(swipe ? index + (dx < 0 ? 1 : -1) : index, true);
    }
    if (wasTap && e.type === 'pointerup') tap(e);
    start = null;
    mode = null;
  }
  stage.addEventListener('pointerup', end);
  stage.addEventListener('pointercancel', end);

  function tap(e) {
    if (e.pointerType === 'mouse') { toggleZoom(e.clientX, e.clientY); return; }
    var now = Date.now();
    if (lastTap && now - lastTap.t < 320 && Math.hypot(e.clientX - lastTap.x, e.clientY - lastTap.y) < 30) {
      lastTap = null;
      toggleZoom(e.clientX, e.clientY);
    } else {
      lastTap = { t: now, x: e.clientX, y: e.clientY };
    }
  }

  stage.addEventListener('wheel', function (e) {
    e.preventDefault();
    zoomAt(e.clientX, e.clientY, s * Math.exp(-e.deltaY * 0.0015));
    apply(false);
  }, { passive: false });

  /* ---------- buttons, keys, history ---------- */

  dlg.addEventListener('click', function (e) {
    if (e.target.closest('[data-lb-close]')) { close(); return; }
    if (e.target.closest('[data-lb-prev]')) { go(index - 1); return; }
    if (e.target.closest('[data-lb-next]')) { go(index + 1); return; }
    var t = e.target.closest('[data-lb-thumb]');
    if (t) go(parseInt(t.getAttribute('data-lb-thumb'), 10));
  });
  dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
  dlg.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
  });
  window.addEventListener('popstate', function () { if (dlg.open) close(true); });
  window.addEventListener('resize', function () { if (dlg.open && s > 1) resetZoom(false); });

  /* ---------- openers and the counter on the product gallery ---------- */

  document.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('[data-lb-open]');
    if (!o || dlg.contains(o)) return;
    e.preventDefault();
    var i = o.getAttribute('data-lb-open');
    if (i === 'current') i = currentSlide();
    open(parseInt(i, 10) || 0, o);
  });

  var galleryTrack = document.getElementById('gallery-track');
  var chipCount = document.querySelector('[data-gallery-count]');
  function currentSlide() {
    if (!galleryTrack || !galleryTrack.clientWidth) return 0;
    return Math.round(galleryTrack.scrollLeft / galleryTrack.clientWidth);
  }
  if (galleryTrack && chipCount) {
    galleryTrack.addEventListener('scroll', function () {
      chipCount.textContent = (currentSlide() + 1) + ' / ' + total;
    }, { passive: true });
    chipCount.textContent = (currentSlide() + 1) + ' / ' + total;   // the page may open on another slide (start image setting)
  }

  /* Mobile image peek: shown under the header once the info sheet has covered the images, until the product
     section has scrolled past; shows a slice of the current image. */
  var peek = document.querySelector('[data-gallery-peek]');
  var sheet = document.querySelector('product-form');
  var details = document.querySelector('.pp-rise--details');
  if (peek && sheet && galleryTrack) {
    var mobile = window.matchMedia('(max-width: 767px)');
    var ticking = false, shown = false;
    var update = function () {
      ticking = false;
      var on = false;
      if (mobile.matches && !dlg.open) {
        var header = document.querySelector('.site-header, header');
        var hb = header ? header.getBoundingClientRect().bottom : 64;
        var covered = sheet.getBoundingClientRect().top < hb + 72;
        var end = (details || sheet).getBoundingClientRect().bottom > hb + 120;
        on = covered && end;
      }
      if (on === shown) return;
      shown = on;
      if (on) {
        var slide = galleryTrack.querySelectorAll('[data-image-id] img')[currentSlide()];
        var peekImg = peek.querySelector('[data-gallery-peek-img]');
        if (slide && peekImg && slide.currentSrc) peekImg.src = slide.currentSrc;
      }
      peek.classList.toggle('is-visible', on);
      peek.tabIndex = on ? 0 : -1;
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  window.PippeiLightbox = { open: open, close: close };
})();
